import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ActiveGame from "./ActiveGame";
import { usePlayersContext, useSocketContext } from "./Common/Contexts";
import { useSocketListener } from "../Hooks/useSocketListener";
import Lobby from "./Lobby";
import RoundReview from "./RoundReview";
import Answer from "../Types/Answer";
import Game from "../Types/Game";
import WinAnimation from "./WinAnimation";
import { ScoreBoard } from "./ScoreBoard";

interface GameViewProps {
  gameId: number;
  game: Game | undefined;
}

const Container = styled.div`
  text-align: center;
  background: var(--color-bg-secondary);
  color: var(--color-text-light);
  border-radius: 0.8em;
  padding: 1em;
`;

const GameView = ({ game, gameId }: GameViewProps) => {
  const socket = useSocketContext();
  const { players } = usePlayersContext();
  const [answers, setAnswers] = useState<{ [socketId: string]: Answer[] }>({});
  useSocketListener(
    "answers",
    socket,
    (newAnswers: { [socketId: string]: Answer[] }) => {
      setAnswers(newAnswers);
    }
  );
  useEffect(() => {
    if (game?.status === "started") {
      setAnswers({});
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [game?.status]);
  const getGameView = () => {
    switch (game?.status) {
      case "not started":
        return <Lobby game={game} gameId={gameId} />;
      case "started":
        return <ActiveGame game={game} gameId={gameId} />;
      case "round done":
        return <RoundReview game={game} gameId={gameId} answers={answers} />;
      case "won":
        return (
          <ScoreBoard
            gamePlayers={game.socketIds.reduce(
              (dict, s) => ({ ...dict, [s]: players[s] }),
              {}
            )}
          />
        );
      case "cancelled":
        return "Game cancelled";
      default:
        return "Game not found";
    }
  };
  return (
    <Container>
      <WinAnimation
        isWon={game?.status === "won"}
        winnerNames={game?.winnerNames ?? []}
      />
      {game && <>{getGameView()}</>}
    </Container>
  );
};

export default GameView;
